import {
  CREATE_CUSTOM_BILLER_CATEGORY,
  UPDATE_CUSTOM_BILLER_CATEGORY,
  UNLOAD_CUSTOM_BILLER_CATEGORY,
  CUSTOM_BILLER_CATEGORY_FETCHED_SUCCESS,
  RESET_CUSTOM_BILLER_CATEGORY,
} from '../../constants/actionTypes';

const initialState = {
  billerCategory: [],
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CUSTOM_BILLER_CATEGORY:
    case UPDATE_CUSTOM_BILLER_CATEGORY:
      return {
        ...state,
        message: action.payload.msg,
      };

    case RESET_CUSTOM_BILLER_CATEGORY:
      return {
        ...state,
        message: '',
      };

    case CUSTOM_BILLER_CATEGORY_FETCHED_SUCCESS:
      return {
        ...state,
        billerCategory: action.payload.billerCategory.map((item) => {
          const newItem = { ...item, id: item.id };
          return newItem;
        }),
        pager: action.payload.pager,
      };

    case UNLOAD_CUSTOM_BILLER_CATEGORY:
      return initialState;

    default:
      return state;
  }
};
